import React, { useState } from 'react';
import { Modal, Tooltip } from 'antd';
import UpdateDomain from './update_domain_form';
import { ReactComponent as EditIcon } from 'assets/images/SVG/icons/edit-icon.svg';
import { SpanButton } from 'component/button_components/button.style';
import { useDispatch } from 'react-redux';
import { clearDropDownData, getDropDownGroupData } from 'redux/slices/getOuGroups';
import { getSingleDomain } from 'redux/slices/domainSlice';
import { SweetSweetAlert } from 'component/sweetalert_components';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';

export default function UpdateDomainModal({ handlelogout, ...record }) {
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [singleDomainData, setSingleDomainData] = useState(null);
  const dispatch = useDispatch();

  const showModal = async () => {
    try {
      setLoader(true);
      const domainData = await dispatch(getSingleDomain(record.id));
      if (domainData.payload && domainData.payload.status === 200) {
        setSingleDomainData(domainData.payload?.data);
        await dispatch(
          getDropDownGroupData({
            ouName: domainData.payload.data?.distinguishedName,
            fqdn: domainData.payload.data?.fqdn,
          })
        );
        setOpen(true);
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoader(false);
    }
  };

  const handleCancel = () => {
    dispatch(clearDropDownData());
    setOpen(false);
  };

  return (
    <>
      <Tooltip title='Update' color='#597081' className='af-superadmin-domain-edit-tooltip'>
        <SpanButton onClick={showModal} className='af-superadmin-domain-edit-tooltip-button'>
          <EditIcon className='af-superadmin-domain-edit-tooltip-icon' />
        </SpanButton>
      </Tooltip>
      {loader && <ModalOpenLoader />}
      {open && (
        <Modal
          className='modal-style af-superadmin-domain-modal'
          open={open}
          onCancel={handleCancel}
          maskClosable={false}
          closable={!singleDomainData.isPrimaryDomain || singleDomainData.superAdmin !== ''}
          footer={[null]}
          width={800}
          centered
        >
          <UpdateDomain
            handleCancel={handleCancel}
            handlelogout={handlelogout}
            setOpen={setOpen}
            showModal={showModal}
            singleDomainData={singleDomainData}
          />
        </Modal>
      )}
    </>
  );
}
